"use strict";

import React from 'react';
import { NavLink } from 'react-router-dom';

function NavListItem(props) {
    const {
        className='nav__list',
        item={pathName:'#',title:'',content:''},
    } = props;
    return (
        <li className={`${className}-item`}>
            <NavLink className={`${className}-item__link`}
                     exact
                     activeClassName={`${className}-item__link--is-active`}
                     to={item.pathName}
                     title={item.title}>
                {item.content}
            </NavLink>
        </li>
    );
}

export default NavListItem;